
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.646 2.236l.364.374.359-.38A5.502 5.502 0 0112.178.964a5.59 5.59 0 011.97-.457l.014.013h.204c.375.001.749.038 1.116.11l.047.009h.161c1.005.283 1.9.854 2.573 1.639a5.112 5.112 0 011.21 2.825v.005c.33 3.022-1.65 7.835-8.754 11.858h-.001l-.753.43-.753-.43c-4.454-2.536-6.656-5.158-7.73-7.297C.405 7.528.44 5.83.525 5.112l.002-.009a5.122 5.122 0 011.218-2.829A5.284 5.284 0 014.33.638h.135l.05-.01C4.89.548 5.274.51 5.657.51a5.776 5.776 0 012.17.472 5.685 5.685 0 011.82 1.254z"}})])
          )
        }
      }
    